import React from 'react'
import moment from 'moment'

import { useResendFormInvite } from './_requests/resendInvite'
import Icon from '../../../components/shapes/Icon'
import Link from '../../../components/actions/Link'

const ResendLink = ({ record }) => {
  const [resend, { loading }] = useResendFormInvite()

  // It wont work on older sends
  if (moment(record.insertedAt).isBefore(moment('10/02/2022', 'DD/MM/YYYY'))) return false
  if (record.sentCount <= record.repliesCount) return false

  return (
    <Link onClick={() => resend(record.id)} block loading={loading}>
      <Icon name="RiMailSendLine" size="1rem" />
    </Link>
  )
}

export default ResendLink
